import { datesHaveSameDayMonthYear } from '~/services/TimeService';

export function isSameCampaignScheduleDate(a?: string | null, b?: string | null): boolean {
  return !!a && !!b && datesHaveSameDayMonthYear(a, b);
}
